@if (isFullStyle) {
  <st-pages-container
    [navigationList]="navigationList"
    [configurations]="configurations"
    [tools]="[]"
    [regions]="[]"
    [locations]="[]"
  >
    <div ngProjectAs="notification-section-template">
      <div class="notification-section-template-sample flex align-items-center">
        <button>
          <em class="icon-chats-circle-solid"></em>
        </button>
        <button>
          <em class="icon-bell"></em>
        </button>
      </div>
    </div>
    <div
      ngProjectAs="page-content"
      class="h-full main-router-outlet"
      [ngClass]="{
        'px-spacing-none pt-spacing-3xl ': isProfileRoute,
        'p-spacing-2xl overflow-scroll': !isProfileRoute && !isDispatchRoute,
      }"
    >
      <router-outlet></router-outlet>
    </div>
  </st-pages-container>
}

@if (!isFullStyle) {
  <div class="p-spacing-2xl">
    <router-outlet></router-outlet>
  </div>
}
